export const CHANGE_PASSWORD_I18N_PREFIX = "features.home.components.change_password";

export const CHANGE_PASSWORD_I18N_KEYS = {
  password_changed_successfully: "password_changed_successfully",
  incorrect_old_password:        "invalid_old_password",
  error_changing_password:       "error_changing_password",
}


// WEBPACK FOOTER //
// ./src/features/home/components/constants/i18n/ChangePasswordi18nConstants.js